import React from "react";
import TopNavBar from "../components/SpearParts/Layouts/TopNavBar";
import TopSearchBar from "../components/SpearParts/Layouts/TopSearchBar";

function CustomerReview() {
  const sectionStyle = {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundImage: "url(/images/bnr-bg.png)",
  };
  return (
    <div>
      <div className="New-Dashboard" style={sectionStyle}>
        <div className="Main-div">
          <TopNavBar />
          <div className="TopSearchBar">
            <TopSearchBar />
          </div>
          <section className="orders contact-info">
            <div className="container mt-3">
              <h3 className="text-uppercase mb-md-5 mb-4"> Testimonials </h3>
              <div className="row about">
                <div className="col-lg-12">
                  <div className="d-md-flex align-items-center mb-md-5 mb-4">
                    <img
                      src="images/testimonail.jpeg"
                      alt="Testimonals"
                      style={{ width: "8%" }}
                      className="mr-4 testi-img"
                    />
                    <div>
                      <h6 className="mt-0 mb-md-3 mb-1">
                        Fast and Flawless Delivery
                      </h6>
                      <p className="mb-1 mb-md-2">
                        Finding the exact spare part for my car used to be a
                        headache. This website's vehicle filter is a
                        game-changer! I simply entered my car's details and had
                        the part in my hands in a few days. The process was
                        fast, accurate, and incredibly convenient..
                      </p>
                      <span className="testi-name">Ahammed</span>
                    </div>
                  </div>
                  <div className="d-md-flex align-items-center mb-5">
                    <img
                      src="images/testimonail.jpeg"
                      alt="Testimonals"
                      style={{ width: "8%" }}
                      className="mr-4 testi-img"
                    />
                    <div>
                      <h6 className="mt-0 mb-md-3 mb-1">An Engineer's Dream</h6>
                      <p className="mb-1 mb-md-2">
                        As a maintenance engineer, sourcing specific industrial
                        parts can be a real challenge. The detailed
                        descriptions, schematics, and accurate filters on this
                        site make finding the right component a quick and
                        reliable process. It's an indispensable tool for my
                        team..
                      </p>
                      <span className="testi-name">Khaled M</span>
                    </div>
                  </div>
                  <div className="d-md-flex align-items-center mb-5">
                    <img
                      src="images/testimonail.jpeg"
                      alt="Testimonals"
                      style={{ width: "8%" }}
                      className="mr-4 testi-img"
                    />
                    <div>
                      <h6 className="mt-0 mb-md-3 mb-1">
                        Genuine Parts, Trusted Service
                      </h6>
                      <p className="mb-1 mb-md-2">
                        I was skeptical about buying parts online, but the
                        experience was incredible. The team confirmed my order
                        and even double-checked the part number with me. The
                        product was 100% genuine, and the service was top-notch.
                        Highly recommended.
                      </p>
                      <span className="testi-name">Sara L</span>
                    </div>
                  </div>
                  <div className="d-md-flex align-items-center mb-5">
                    <img
                      src="images/testimonail.jpeg"
                      alt="Testimonals"
                      style={{ width: "8%" }}
                      className="mr-4 testi-img"
                    />
                    <div>
                      <h6 className="mt-0 mb-md-3 mb-1">
                        Saved Time and Money
                      </h6>
                      <p className="mb-1 mb-md-2">
                        I used to drive all over Dubai to find parts for my
                        classic car. With this website, I can do it all from
                        home. The prices are competitive, and the time I've
                        saved is priceless. It's a fantastic service for anyone
                        in the UAE..
                      </p>
                      <span className="testi-name">karthik </span>
                    </div>
                  </div>
                  <div className="d-md-flex align-items-center mb-5">
                    <img
                      src="images/testimonail.jpeg"
                      alt="Testimonals"
                      style={{ width: "8%" }}
                      className="mr-4 testi-img"
                    />
                    <div>
                      <h6 className="mt-0 mb-md-3 mb-1">
                        The Perfect Fit, Every Time
                      </h6>
                      <p className="mb-1 mb-md-2">
                        I've ordered a few times now—from car parts to some
                        hard-to-find components for a home project—and every
                        single item has been the perfect fit. The precision of
                        their search and the quality of their stock are
                        unmatched. I wouldn't go anywhere else.
                      </p>
                      <span className="testi-name">Abdullah B</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default CustomerReview;
